import * as overlayAnim from '../animations/contentOverlay';

let overlayOpen = false;

const contentOverlayTrigger = () => {
    const triggerers = document.querySelectorAll('.js-overlay-trigger');

    /*
    if ( trigger ) {
        console.log(trigger);
        trigger.addEventListener('click', (e) => {
            e.preventDefault();

            if ( !overlayOpen ) {
                overlayAnim.overlayReveal();
            } else {
                overlayAnim.overlayHide();
            }

            overlayOpen = !overlayOpen;
        });
    }
    */

    triggerers.forEach(trigger => {
        console.log(trigger);

        trigger.addEventListener('click', (e) => {
            e.preventDefault();

            if ( !overlayOpen ) {
                overlayAnim.overlayReveal(trigger);
            } else {
                overlayAnim.overlayHide(trigger);
            }

            overlayOpen = !overlayOpen;
        });
    });


    const close_element = document.querySelector('.close-overlay-desktop');
    close_element.addEventListener('click', (e) => {
        e.preventDefault();

            overlayAnim.overlayHide();
        

        overlayOpen = !overlayOpen;
    });
};

contentOverlayTrigger();